import _ from 'lodash';
import moment from 'moment';

// import flatpickr from "flatpickr";

function EventCtrl($rootScope, $scope, $state, $stateParams, toastr, AuthService, PlanService, PlayerService, AnalysisService, UserService, AppContextService, $ngConfirm, AdminService) {
  'ngInject';

  
  var vm = this;
  vm.appContext = AppContextService.context;
  vm.appContext.my_team = null;
  vm.appContext.oppo_team = null;


  // 좌측 상단에 팀명 표시를 위해서
  if (!$stateParams.manager_admin_team_id) {
    // 팬이 선택한 user_id
    if ($stateParams.fan_user_id) {
      UserService.teamInfo({id: $stateParams.fan_user_team_id}).then(function(res2) {
        vm.appContext.my_team = {
          team_id: vm.appContext.info.team_id,
          team_name: vm.appContext.info.team_name,
          country_name: vm.appContext.info.country_name,
          parent_team_name: res2.data.name
        };
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
    // 팬이 선택한 team_id
    else if ($stateParams.fan_team_id) {
      UserService.teamInfo({id: $stateParams.fan_team_id}).then(function(res2) {
        vm.appContext.my_team = {
          team_id: vm.appContext.info.team_id,
          team_name: vm.appContext.info.team_name,
          country_name: vm.appContext.info.country_name,
          parent_team_name: res2.data.name
        };
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
    // 감독-선수 소속팀 관련 수정
    // 감독-선수가 선택한 team_id
    else if ($stateParams.coach_player_team_id) {
      UserService.teamInfo({id: $stateParams.coach_player_team_id}).then(function(res2) {
        vm.appContext.my_team = {
          team_id: vm.appContext.info.team_id,
          team_name: vm.appContext.info.team_name,
          country_name: vm.appContext.info.country_name,
          parent_team_name: res2.data.name
        };
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
    else {
      UserService.teamInfo({id: vm.appContext.info.parent_team_id}).then(function(res2) {
        vm.appContext.my_team = {
          team_id: vm.appContext.info.team_id,
          team_name: vm.appContext.info.team_name,
          country_name: vm.appContext.info.country_name,
          parent_team_name: res2.data.name
        };
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  }


  var plans;
  vm.mode = 'list';
  vm.year = $stateParams.year;
  vm.month = $stateParams.month;

  vm.monthRanges = _.range(1, 13).map(num => ('0' + num).slice(-2));

  $scope.$watch('vm.year', function (newVal, oldVal) {
    if (newVal) {
      vm.filterGames();
    }
  });

  $scope.$watch('vm.month', function (newVal, oldVal) {
    if (newVal) {
      vm.filterGames();
    }
  });

  var date, time;

  var setDateTime = function (d) {
    var tzoffset = (new Date(d)).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(new Date(d) - tzoffset)).toISOString().slice(0, -5);
    date = localISOTime.split("T")[0].split("-").join(".");
    time = localISOTime.split("T")[1];
  }

  if (!vm.dateTime) {
    vm.dateTime = new Date();
    setDateTime(vm.dateTime);
  }

  vm.dateTimeChanged = function (dateTime) {
    setDateTime(dateTime._d);
  }

  vm.setEvent = function () {
    var functionName = $stateParams.type_code == 'game' ? 'setGame' : 'setTrainingRoot';

    // 전체관리자가 경기, 훈련 생성
    if ($stateParams.manager_admin_team_id && vm.appContext.user.login_id === 'ceo@sa21c.com') {

      // (1) 전체관리자에게 팀을 할당하기 위해서 user_type_id 를 23 (전체관리자) 에서 10 (단장) 으로 변경 - 팀 할당은 구단주와 단장에게만 가능함
      UserService.modify({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        user_id: vm.appContext.user.user_id,
        user_type_id: 10
      })
        .then(function (res) {

          console.log('success (1)');

          // (2) 전체관리자에게 팀을 할당
          var setTeamData = {
            login_id: vm.appContext.user.login_id,
            uuid: vm.appContext.user.uuid,
            user_id: vm.appContext.user.user_id,
            team_id: +$stateParams.manager_admin_team_id
          };

          AdminService.setTeam(setTeamData).then(function(res) {

            console.log('success (2)');
            
            // (3) 전체관리자가 본인 소유 팀목록을 확인 - team_id 체크 - login_id 와 passwd 를 얻음
            var myTeamsData = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid
            };
          
            UserService.myTeams(myTeamsData).then(function(res) {

              console.log('success (3)');
              
              var obj = _.find(res.data.list, {
                team_id: +$stateParams.manager_admin_team_id
              });

              if (obj) {
                // (4) login_id 와 passwd 를 사용해서 login 을 해서 uuid 를 받음
                UserService.login({
                  login_id: obj.login_id,
                  passwd: obj.passwd
                }).then(function (res) {

                  console.log('success (4)');

                  // (5) 발급받은 login_id, uuid 로 경기 생성
                  var data = {
                    login_id: res.data.login_id,
                    uuid: res.data.uuid,
                    date: $('#flatpickr').val().split(' ')[0],
                    time: $('#flatpickr').val().split(' ')[1]
                  };
              
                  PlanService[functionName](data)
                    .then(function (res) {
                      document.getElementById('event-add-modal').style.display = 'none'
                      getEvents();
                    })
                    .catch(function (error) {
                      console.log("An error occured : " + error);
                    })

                }).catch(function(err) {
                  console.log(err);
                });
              }

              // (6) 전체관리자의 user_type_id 를 10 (단장) 에서 23 (전체관리자) 으로 변경
              UserService.modify({
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                user_id: vm.appContext.user.user_id,
                user_type_id: 23
              })
                .then(function (res) {
                  console.log('success (6)');
                })
                .catch(function (error) {
                  console.log('ERROR', error);
                });

            }).catch(function(err) {
              console.log(err);
            });

          }).catch(function(err) {
            console.log(err);
          });

        })
        .catch(function (error) {
          console.log('ERROR', error);
        });

    } else {
      var data = {
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        date: $('#flatpickr').val().split(' ')[0],
        time: $('#flatpickr').val().split(' ')[1]
      };

      PlanService[functionName](data)
        .then(function (res) {
          document.getElementById('event-add-modal').style.display = 'none'
          getEvents();
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        });
    }
  }

  vm.filterGames = function (mode) {
    if (!mode) {
      mode = vm.selectedPeriodBtn;
    }

    var startOfWeek = moment().startOf('isoWeek').toDate();   // 이번주의 시작일
    var endOfWeek   = moment().endOf('isoWeek').toDate();     // 이번주의 끝일
    var startOfMonth = moment().startOf('month').toDate();   // 이번달의 시작일
    var endOfMonth   = moment().endOf('month').toDate();     // 이번달의 끝일
    var lastStartOfWeek = moment().subtract(1, 'weeks').startOf('isoWeek').toDate();  // 이전주의 시작일
    var lastEndOfWeek = moment().subtract(1, 'weeks').endOf('isoWeek').toDate();      // 이전주의 끝일
    var nextStartOfWeek = moment().add(1, 'weeks').startOf('isoWeek').toDate(); // 이전주의 시작일
    var nextEndOfWeek = moment().add(1, 'weeks').endOf('isoWeek').toDate();     // 이전주의 끝일

    var check = (vm.year && vm.month) || (!vm.year && !vm.month);

    if (!check) {
      console.log('check ERROR...', check);
      return;
    }
    var yearMonth = '';
    if (vm.year && vm.month) {
      yearMonth = vm.year + '.' + vm.month;
    }

    // console.log('filter....', yearMonth);
    // console.log('filter....', _.filter(plans, {type:'경기'}));
    if (yearMonth) {
      var items = _.filter(plans, function (p) {
        return p.type === $stateParams.type_name && p.date.startsWith(yearMonth)
      });
      vm.items = _.orderBy(items, ['id'], ['desc']);
    }
    // 이전주
    else if (mode === 'lastWeek') {
      var items = _.filter(plans, { type: $stateParams.type_name });
      items = _.filter(items, function(item) {  
        return +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) >= +lastStartOfWeek && +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) <= +lastEndOfWeek;
      });

      vm.items = _.orderBy(items, ['id'], ['desc']);
    }
    // 이번주
    // 다음주
    else if (mode === 'currentWeek') {
      var items = _.filter(plans, { type: $stateParams.type_name });
      items = _.filter(items, function(item) {  
        return +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) >= +startOfWeek && +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) <= +endOfWeek;
      });

      vm.items = _.orderBy(items, ['id'], ['desc']);
    }
    // 다음주
    else if (mode === 'nextWeek') {
      var items = _.filter(plans, { type: $stateParams.type_name });
      items = _.filter(items, function(item) {  
        return +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) >= +nextStartOfWeek && +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) <= +nextEndOfWeek;
      });

      vm.items = _.orderBy(items, ['id'], ['desc']);
    }
    else {
      var items = _.filter(plans, { type: $stateParams.type_name });
      
      // year month 가 지정되지 않은 경우, default 는 이번달의 일정을 보여줌
      if (mode !== 'all') {
        items = _.filter(items, function(item) {  
          return +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) >= +startOfMonth && +(new Date((item.date + ' ' + item.time).replace(/\./g, '/'))) <= +endOfMonth;
        });
      }

      vm.items = _.orderBy(items, ['id'], ['desc']);
    }
  }

  // 최초 로드시 모두보기가 선택되어 있도록
  vm.selectedPeriodBtn = 'all';

  vm.setToday = function () {
    vm.year = new Date().toISOString().slice(0, 4);
    vm.month = new Date().toISOString().slice(5, 7);
  }

  vm.lastWeek = function() {
    vm.filterGames('lastWeek');
  };

  vm.currentWeek = function() {
    vm.filterGames('currentWeek');
  };

  vm.nextWeek = function() {
    vm.filterGames('nextWeek');
  };

  vm.remove = function (id) {
    vm.eventRemovePasswd = null;

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까? <input type="password" ng-model="vm.eventRemovePasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              passwd: vm.eventRemovePasswd
              // game_id: id
            }

            

            if ($stateParams.type_code === 'game') {
              data.game_id = id;
              console.log('data', data);
              PlanService.removeGame(data)
                .then(function (res) {
                  if (res.data.result == 'SUC') {
                    toastr.success('삭제 하였습니다.');
                    getEvents();
                  } else if (res.data.result == 'PASSWD_MISMATCH') {
                    toastr.error('비밀번호가 일치하지 않습니다.');
                  }
                })
                .catch(function (error) {
                  console.log("An error occured : " + error);
                });
            }
            else {
              data.training_root_id = id;
              console.log('data', data);
              PlanService.removeTraining(data)
                .then(function (res) {
                  if (res.data.result == 'SUC') {
                    toastr.success('삭제 하였습니다.');
                    getEvents();
                  } else if (res.data.result == 'PASSWD_MISMATCH') {
                    toastr.error('비밀번호가 일치하지 않습니다.');
                  }
                })
                .catch(function (error) {
                  console.log("An error occured : " + error);
                });
            }

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
          // action: function (scope, button) {
          // }
        },
      }
    });

  }

  var getEvents = function () {
    var planData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid
    };

    if (vm.appContext.role2 === 'sa21c' && !$stateParams.manager_admin_team_id) {
      return;
    }

    // 전체관리자가 선택한 team_id
    if ($stateParams.manager_admin_team_id) {
      planData.team_id = $stateParams.manager_admin_team_id;
    }
    // 팬이 선택한 team_id
    else if ($stateParams.fan_team_id) {
      planData.team_id = $stateParams.fan_team_id;
    }
    // 팬이 선택한 user_id
    else if ($stateParams.fan_user_id) {
      planData.user_id = $stateParams.fan_user_id;
      if ($stateParams.fan_user_team_id) {
        planData.team_id = $stateParams.fan_user_team_id;
      }
    }
    // 감독-선수 소속팀 관련 수정
    // 감독-선수가 선택한 team_id
    else if ($stateParams.coach_player_team_id) {
      planData.team_id = $stateParams.coach_player_team_id;
    }

    PlanService.plans(planData).then(function (res) {
      // console.log('All games', res);
      plans = res.data.plans;
      vm.filterGames();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };
  getEvents();

  const fp = flatpickr("#flatpickr", {
    defaultDate: new Date(),
    enableTime: true,
    enableSeconds: true,
    dateFormat: "Y.m.d H:i:S",
    timeFormat: "H:i",
    time_24hr: true,
    minuteIncrement: 1,
  });

  console.log('fp', fp);

  vm.setDefault = function() {
    console.log('setDefault')
    fp.setDate(new Date());
  }

}

export default {
  name: 'EventCtrl',
  fn: EventCtrl
};
